import React, { Component } from "react";
import Marking from "../../../components/Marking/Marking";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AMarkingForm
Description : Componente que invoca al componente Marking.
Date Autor Modification
================================================================================
14/04/2026 scoca – Creacióm
================================================================================ */
class MarkingForm extends Component {
    render() {
        return (
            <Marking />
        )
    }
}

export default MarkingForm;